// extracted by mini-css-extract-plugin
module.exports = {"wzq9bb6":"wzq9bb6"};